import React from "react";
import styled from "styled-components";

type CardSectionProps = {
  id: string;
  title: string;
  children: React.ReactNode;
};

export const CardSection = ({ id, title, children }: CardSectionProps) => {
  return (
    <StyledCardSection id={id}>
      <p className="title">{title}</p>
      <div className="content">{children}</div>
    </StyledCardSection>
  );
};

const StyledCardSection = styled.section`
  box-sizing: border-box;
  overflow-y: auto;
  border: 0.2rem solid var(--text-gray-1);
  width: 100%;
  height: max-content;
  max-height: 100%;
  padding: 1.6rem;
  background-color: var(--bg-gray-0);
  border-radius: 0.8rem;
  display: flex;
  flex-direction: column;
  &::-webkit-scrollbar-track {
    background-color: var(--bg-gray-0);
  }
  &::-webkit-scrollbar-thumb {
    border: 0.3rem solid var(--bg-gray-0);
  }

  & > .title {
    font: var(--title-medium);
    color: var(--sec-orange-4);
  }
  & > .content {
    margin: 0.8rem 3rem 0;
    max-height: 100%;
  }
`;
